// extracted by mini-css-extract-plugin
export default {"playsound-btn":"PlaySound_playsound-btn__KOyq+"};